<template>
  <div class="text-left">
    <div class="row">
      <div class="col-4">
        <div
          v-for="organization in organizations.filter(
            o => o.Parent_Organization_Id == 1
          )"
          :key="organization.Organization_Id"
          class="row"
        >
          <div class="col">
            <i
              class="material-icons float-left pointer mt-2"
              v-bind:id="organization.Organization_Id + 'toggleIcon'"
              data-toggle="collapse"
              v-bind:href="'#details' + organization.Organization_Id"
              role="button"
              aria-expanded="false"
              v-on:click="
                updateToggleIcon(
                  '#' + organization.Organization_Id + 'toggleIcon'
                )
              "
              >add</i
            >
            <h5 class="mt-2">{{ organization.Name }}</h5>
            <div
              class="collapse"
              v-bind:id="'details' + organization.Organization_Id"
            >
              <div
                v-for="(user, index) in organization.Users"
                :key="user.User_Id"
                class="row pt-2"
                v-bind:class="{ 'light-background': index % 2 === 1 }"
              >
                <div class="col-auto">
                  <h6
                    class="pointer"
                    v-on:click="manageUser(user, organization)"
                  >
                    {{ user.First_Name }} {{ user.Last_Name }}
                  </h6>
                  <div
                    v-for="permission in user.Permissions"
                    :key="permission.Permission_Id"
                    class="row"
                  >
                    <div class="col">
                      <p>
                        {{ permission.Organization.Name }}:
                        {{ permission.Permission.Title }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="childOrganization in organizations.filter(
                o => o.Parent_Organization_Id == organization.Organization_Id
              )"
              :key="childOrganization.Organization_Id"
              class="row ml-4 mt-4"
            >
              <div class="col">
                <i
                  class="material-icons float-left pointer"
                  v-bind:id="childOrganization.Organization_Id + 'toggleIcon'"
                  data-toggle="collapse"
                  v-bind:href="'#details' + childOrganization.Organization_Id"
                  role="button"
                  aria-expanded="false"
                  v-on:click="
                    updateToggleIcon(
                      '#' + childOrganization.Organization_Id + 'toggleIcon'
                    )
                  "
                  >add</i
                >
                <h5>{{ childOrganization.Name }}</h5>
                <div
                  class="collapse"
                  v-bind:id="'details' + childOrganization.Organization_Id"
                >
                  <div
                    v-for="(user, index) in childOrganization.Users"
                    :key="user.User_Id"
                    class="row pt-2"
                    v-bind:class="{ 'light-background': index % 2 === 1 }"
                  >
                    <div class="col">
                      <h6
                        class="pointer"
                        v-on:click="manageUser(user, childOrganization)"
                      >
                        {{ user.First_Name }} {{ user.Last_Name }}
                      </h6>
                      <div
                        v-for="permission in user.Permissions"
                        :key="permission.Permission_Id"
                        class="row"
                      >
                        <div class="col">
                          <p>
                            {{ permission.Organization.Name }}:
                            {{ permission.Permission.Title }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-for="grandchildOrganization in organizations.filter(
                  o =>
                    o.Parent_Organization_Id ==
                    childOrganization.Organization_Id
                )"
                :key="grandchildOrganization.Organization_Id"
                class="row ml-4 mt-4"
              >
                <div class="col">
                  <i
                    class="material-icons float-left pointer"
                    v-bind:id="
                      grandchildOrganization.Organization_Id + 'toggleIcon'
                    "
                    data-toggle="collapse"
                    v-bind:href="
                      '#details' + grandchildOrganization.Organization_Id
                    "
                    role="button"
                    aria-expanded="false"
                    v-on:click="
                      updateToggleIcon(
                        '#' +
                          grandchildOrganization.Organization_Id +
                          'toggleIcon'
                      )
                    "
                    >add</i
                  >
                  <h5>{{ grandchildOrganization.Name }}</h5>
                  <div
                    class="collapse"
                    v-bind:id="
                      'details' + grandchildOrganization.Organization_Id
                    "
                  >
                    <div
                      v-for="(user, index) in grandchildOrganization.Users"
                      :key="user.User_Id"
                      class="row pt-2"
                      v-bind:class="{ 'light-background': index % 2 === 1 }"
                    >
                      <div class="col">
                        <h6
                          class="pointer"
                          v-on:click="manageUser(user, grandchildOrganization)"
                        >
                          {{ user.First_Name }} {{ user.Last_Name }}
                        </h6>
                        <div
                          v-for="permission in user.Permissions"
                          :key="permission.Permission_Id"
                          class="row"
                        >
                          <div class="col">
                            <p>
                              {{ permission.Organization.Name }}:
                              {{ permission.Permission.Title }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <h4>{{ editingUser.First_Name }} {{ editingUser.Last_Name }}</h4>
        <button
          class="btn btn-primary float-right"
          v-on:click="savePermissions"
        >
          Save Changes
        </button>
        <div
          v-if="
            fundsGrantedOrg != {} &&
              fundsGrantedOrg != undefined &&
              editingUser.First_Name != undefined
          "
          class="ml-2 mt-4"
        >
          <h5>{{ fundsGrantedOrg.Name }} (Entire System)</h5>
          <select>
            <option v-for="group in permissionGroups" :key="group.description">
              {{ group.description }}
            </option>
          </select>
          <div
            v-for="permission in permissions"
            :key="permission.Permission_Id"
            class="form-check ml-4"
          >
            <input
              class="form-check-input"
              type="checkbox"
              v-model="editingUserPermissions"
              v-bind:value="{
                Organization: fundsGrantedOrg.Organization_Id,
                Permission: permission.Permission_Id
              }"
              v-bind:id="
                permission.Permission_Id + '-' + fundsGrantedOrg.Organization_Id
              "
            />
            <label
              class="form-check-label"
              v-bind:for="
                permission.Permission_Id + '-' + fundsGrantedOrg.Organization_Id
              "
            >
              {{ permission.Title
              }}<!-- -- Organization: {{ fundsGrantedOrg.Organization_Id }}, Permission: {{ permission.Permission_Id }}-->
            </label>
          </div>
        </div>
        <div
          class="ml-2 mt-4"
          v-for="org in editingOrganizations"
          :key="org.Organization_Id"
        >
          <h5>
            {{ org.Name }} ({{
              organizationTypes.find(
                t => t.Organization_Type_Id == org.Organization_Type_Id
              ).Name
            }})
          </h5>
          <div
            v-for="permission in permissions"
            :key="permission.Permission_Id"
            class="form-check ml-4"
          >
            <input
              class="form-check-input"
              type="checkbox"
              v-model="editingUserPermissions"
              v-bind:value="{
                Organization: org.Organization_Id,
                Permission: permission.Permission_Id
              }"
              v-bind:id="permission.Permission_Id + '-' + org.Organization_Id"
            />
            <label
              class="form-check-label"
              v-bind:for="permission.Permission_Id + '-' + org.Organization_Id"
            >
              {{ permission.Title
              }}<!-- -- Organization: {{ org.Organization_Id }}, Permission: {{ permission.Permission_Id }}-->
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { permissionGroups } from "@/constants/PermissionGroups";

export default {
  name: "UserPermissions",
  props: {
    AccountId: String
  },
  data() {
    return {
      organizations: [],
      permissions: [],
      editingUser: {},
      editingOrganizations: [],
      editingUserPermissions: [],
      fundsGrantedOrg: {},
      organizationTypes: [],
      permissionGroups: permissionGroups
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.loadData(this.AccountId);
    this.$store.commit("updateLoading", false);
    var allPermissions = await this.$getAllPermissions();
    this.permissions = this.$canManageAllAccounts(
      this.$store.getters.user.Permissions
    )
      ? allPermissions
      : allPermissions.filter(p => p.Permission_Id > 6);
    this.organizationTypes = await this.$getOrganizationTypes();
  },
  methods: {
    async loadData(accountId) {
      if (
        this.$canManageAllAccounts(this.$store.getters.user.Permissions) ||
        this.$canManageMyAccount(this.$store.Getters.user.Permissions)
      ) {
        await this.loadAllPermissions(accountId);
      } else if (
        this.$canManageOrganization(
          this.$store.getters.user.Organization_Id,
          this.$store.getters.user.Permissions
        )
      ) {
        await this.loadOrganizationPermissions(
          this.$store.getters.user.Organization_Id
        );
      } else {
        this.$showSnackbar(
          "You do not have permission to manage permissions.",
          true
        );
      }
    },
    async loadAllPermissions(accountId) {
      var view = this;
      view.$store.commit("updateLoading", true);
      await view
        .$getAccountPermissions(accountId)
        .then(account => {
          view.organizations = account.Organizations;
          console.log(view.organizations);
          view.fundsGrantedOrg = account.Organizations.find(
            o => o.Organization_Id == 1
          );
          view.$store.commit("updateLoading", false);
        })
        .catch(err => {
          console.log(err);
          view.$store.commit("updateLoading", false);
        });
    },
    async loadOrganizationPermissions(organizationId) {
      console.log("Load Organization Permissions: " + organizationId);
    },
    manageUser(user, organization) {
      this.editingUser = user;
      this.editingUserPermissions = this.getUserCurrentPermissions(user);
      this.editingOrganizations = [];
      var newOrgs = [organization];
      while (newOrgs.length > 0) {
        this.editingOrganizations = this.editingOrganizations.concat(newOrgs);
        var orgs = newOrgs;
        newOrgs = [];
        orgs.forEach(org => {
          newOrgs = this.organizations.filter(
            o => o.Parent_Organization_Id == org.Organization_Id
          );
        });
      }
    },
    async savePermissions() {
      var view = this;
      view.$store.commit("updateLoading", true);
      var currentPermissions = view.getUserCurrentPermissions(view.editingUser);
      var addedPermissions = view.editingUserPermissions.filter(
        p =>
          !currentPermissions.some(c => {
            return (
              p.Permission == c.Permission && p.Organization == c.Organization
            );
          })
      );
      addedPermissions = addedPermissions.map(p => {
        var permission = {};
        permission.User_Id = parseInt(view.editingUser.User_Id);
        permission.Permission_Id = parseInt(p.Permission);
        permission.Organization_Id = parseInt(p.Organization);
        return permission;
      });
      var removedPermissions = view.editingUser.Permissions.filter(
        c =>
          !view.editingUserPermissions.some(p => {
            return (
              p.Permission == c.Permission.Permission_Id &&
              p.Organization == c.Organization.Organization_Id
            );
          })
      );
      try {
        await view
          .$addPermissions(addedPermissions, parseInt(view.editingUser.User_Id))
          .then(async () => {
            await view
              .$removePermissions(
                removedPermissions.map(p => parseInt(p.UserPermission_Id)),
                parseInt(view.editingUser.User_Id)
              )
              .then(permissions => {
                var orgIndex = view.organizations.findIndex(o =>
                  o.Users.some(u => u.User_Id == view.editingUser.User_Id)
                );
                var userIndex = view.organizations[orgIndex].Users.findIndex(
                  u => u.User_Id == view.editingUser
                );
                view.editingUser.Permissions = permissions;
                var organization = view.organizations[orgIndex];
                organization.Users[userIndex] = view.editingUser;
                view.$set(view.organizations, orgIndex, organization);
                this.$store.commit("updateLoading", false);
              });
          });
      } catch (err) {
        this.$store.commit("updateLoading", false);
      }
    },
    getUserCurrentPermissions(user) {
      return user.Permissions.map(p => {
        var permission = {};
        permission.Organization = p.Organization.Organization_Id;
        permission.Permission = p.Permission.Permission_Id;
        return permission;
      });
    },
    updateToggleIcon(iconId) {
      var icon = $(iconId);
      if (icon.text() == "add") {
        icon.text("remove");
      } else {
        icon.text("add");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  margin-bottom: 0.2rem;
}
</style>
